// extracted by mini-css-extract-plugin
export default {"rows":"StudentSense_rows__1fa1V","row":"StudentSense_row__TMBxL","button":"StudentSense_button__0dGA5"};